module.exports = __webpack_public_path__ + "img/delete-mob.10c305c5.svg";